export { default } from './InformationPaywall';
